import React from 'react';

import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

const StudentCreate = (props) => (
  <Create {...props} title="Edit student">
    <SimpleForm>
      {/* <TextInput disabled source="id" /> */}
      <TextInput source="first_name" />
      <TextInput source="last_name" />
      <TextInput source="email" />
      <TextInput source="mobile" />
      <ReferenceInput source="class_id" reference="classes" perPage={200}>
        <SelectInput label="Class" source="class_id" optionText="class_code" />
      </ReferenceInput>
      <TextInput source="household_hash" sx={{ width: 400 }} />
    </SimpleForm>
  </Create>
);

export default StudentCreate;

